import { classes } from '@/utils/classes/classes';
import './styles/default.scss';

type Props = {
    count?: number;
};

export const NotificationIcon = ({ count }: Props) => {
    if (count === 0) {
        return null;
    }

    return <span className={classes('notification-item', Boolean(count) && 'item-number')}>{count}</span>;
};
